import type { Maybe } from '@amazon/vinyl-util'

/** One action, ready for the AMTC `clientActionList`. */
export interface MetrixAction {
    readonly actionName: string
    /** Epoch SECONDS, fractional (not floored), as the AMTC wire carries it. */
    readonly timestamp: number
    readonly additionalDetails: Record<string, string>
    /** GH's `ContentInfo` rows, every value a string, as the MIS model declares them. */
    readonly contentInfo?: readonly Record<string, string>[]
}

/** Raw `additionalDetails`; a null/undefined attribute is dropped from the payload. */
export type WireDetails = Readonly<Record<string, Maybe<string | number | boolean>>>

/** The wire carries every attribute as a string. */
export function toAdditionalDetails(raw: WireDetails): Record<string, string> {
    const out: Record<string, string> = {}
    for (const [key, value] of Object.entries(raw)) {
        if (value != null) out[key] = typeof value === 'string' ? value : String(value)
    }
    return out
}

/** Where the MusicMetrix sink delivers its actions. */
export interface MetrixActionQueue {
    enqueue(action: MetrixAction): void
    flush(options?: { readonly keepalive?: boolean }): void
}
